module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921121149_T.20b448e8.jpg";